import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";
import type { Nullable } from "shared/types";

import type OrganisationReportSpec from "./OrganisationReportSpec";

@Model()
class OrganisationReportSpecsStreams extends ApplicationRecord {
  static jsonapiType = "organisation_report_specs_streams";

  @Attr() backgroundColour: string;

  @Attr() headingSummary: string;

  @Attr() imageUrl: string;

  @Attr() label: string;

  @Attr() labelAlign: Nullable<string>;

  @Attr() order: number;

  @BelongsTo() organisationReportSpec: OrganisationReportSpec;

  @Attr() streamId: number;

  @Attr() subLabel: string;

  @Attr() subLabelAlign: Nullable<string>;

  @Attr() textColour: string;

  @Attr() type: string;
}

export default OrganisationReportSpecsStreams;
